import { createFileRoute } from "@tanstack/react-router";

import { PendingTransaction } from "../-components/PendingTransaction";

export const Route = createFileRoute("/_authenticated/trade/pending/$taskId")({
  component: PendingTransaction,
  context: () => ({ permissions: "trade.pending" }),
});
